import React, { useState, useEffect } from "react";
import axios from "axios";
import apiService from "../config";
import { useLanguage } from '../StoreContext/LanguageContext';

const ProposalDetails = ({
  selectedDistrict,
  selectedTaluka,
  selectedVillage,
  districts = [],
  availableTalukas = [],
  availableVillages = [],
  onSubmit,
  onClose,
}) => {
  const [formData, setFormData] = useState({
    // Main proposal fields
    acquisition_proposal_no: "",
    proposal_amount: "",
    acquisition_proposal_date: "",
    propsal_description: "",
    date_of_extension: "",
    project_description: "",
    project_social_benfit: "",
    displacement_reason: "",
    social_impact: "",
    acquisition_agency: "",
    acquisition_purpose: "",
    area_unit: "",

    // Land information
    villageType: "",
    surveyNumber: "",
    surveyType: "",
    acquisition_area: "",
    landholderName: "",
    total_area: "",
    aquired_area: "",
    no_of_landparcel: "",
    status: "",

    // Project details
    proposalTitle: "",
    proposalType: "",
    department: "",
    subdepartment: "",
    priority: "",
    estimatedCost: "",
    budgetHead: "",
    financialYear: "",
    projectDuration: "",
    beneficiaries: "",
    objectives: "",
    expectedOutcome: "",
    exemption_approval: "",
    irrigationProject: false,
    socialImpactSurvey: false,
    govAuthorityNote: false,

    proposedBy: {
      name: "",
      designation: "",
      contactNumber: "",
      email: "",
    },
    documents: {
      detailedProjectReport: false,
      costEstimate: false,
      feasibilityStudy: false,
      environmentalClearance: false,
    },
  });
  const { language, translations } = useLanguage();
  const [documentFile, setDocumentFile] = useState(null);
  const [currentProjectId, setCurrentProjectId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [loadingVillages, setLoadingVillages] = useState(false);
  const [exemptionApplicable, setExemptionApplicable] = useState("");
  const [exemptionType, setExemptionType] = useState("");
  const [exemptionNumber, setExemptionNumber] = useState("");
  const [exemptionFile, setExemptionFile] = useState(null);
  const [areaUnits, setAreaUnits] = useState([]);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    type: 'success',
    title: '',
    message: ''
  });

  const showAlert = (type, title, message) => {
    setAlertConfig({ type, title, message });
    setShowAlertModal(true);
    // Auto-hide after 4 seconds
    setTimeout(() => setShowAlertModal(false), 4000);
  };

  useEffect(() => {
    const fetchAreaUnits = async () => {
      try {
        const res = await apiService.getAreaUnits();
        const units = res.data || [];
        setAreaUnits(units);

        // Set default to hectare if not selected
        const hectareUnit = units.find(
          (unit) =>
            (unit.unit_code || "").toLowerCase() === "hect-are" ||
            (unit.unit_name || "").toLowerCase().includes("hectare-are")
        );
        if (hectareUnit && !formData.area_unit) {
          setFormData((prev) => ({
            ...prev,
            area_unit: hectareUnit.unit_name, // ✅ store name not ID
          }));
        }
      } catch (err) {
        console.error("Failed to load area units:", err.message);
      }
    };
    fetchAreaUnits();
  }, []);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      district: selectedDistrict || "",
      taluka: selectedTaluka || "",
      village: selectedVillage || "",
    }));
  }, [selectedDistrict, selectedTaluka, selectedVillage]);

  // NEW: useEffect to get project_id from localStorage on component mount
  useEffect(() => {
    try {
      // Get selected project from localStorage
      const selectedProject = JSON.parse(
        localStorage.getItem("selectedProject") || "{}"
      );
      const projectId =
        selectedProject?.project_id || selectedProject?.id || "";

      // If no selected project, try to get from current project data
      if (!projectId) {
        const currentProjectData = JSON.parse(
          localStorage.getItem("currentProjectData") || "{}"
        );
        const fallbackProjectId =
          currentProjectData?.project_id || currentProjectData?.id || "";
        setCurrentProjectId(fallbackProjectId);
      } else {
        setCurrentProjectId(projectId);
      }

      console.log(
        "Current Project ID set to:",
        projectId || "No project selected"
      );
    } catch (error) {
      console.error("Error getting project ID from localStorage:", error);
      setCurrentProjectId("");
    }
  }, []);

  //fetch talukas on change of district
  useEffect(() => {
    if (!formData.district) {
      setTalukas([]);
      setFormData((prev) => ({ ...prev, taluka: '', village: '' }));
      return;
    }

    const fetchTalukas = async () => {
      try {
        setLoadingTalukas(true);
        const response = await apiService.getTalukas(formData.district);
        const talukaList = Array.isArray(response.data) ? response.data : [];
        setTalukas(talukaList);
        setFormData((prev) => ({ ...prev, taluka: '', village: '' })); // Reset selected taluka & village
      } catch (error) {
        console.error('Error fetching talukas:', error);
        setTalukas([]);
      } finally {
        setLoadingTalukas(false);
      }
    };

    fetchTalukas();
  }, [formData.district]);

  // fetch villages on change of taluka
  useEffect(() => {
    if (!formData.district || !formData.taluka) {
      setVillages([]);
      setFormData((prev) => ({ ...prev, village: '' }));
      return;
    }

    const fetchVillages = async () => {
      try {
        setLoadingVillages(true);
        const response = await apiService.getVillages(formData.district, formData.taluka);
        const villageList = Array.isArray(response.data) ? response.data : [];
        setVillages(villageList);
        setFormData((prev) => ({ ...prev, village: '' })); // Reset selected village
      } catch (error) {
        console.error('Error fetching villages:', error);
        setVillages([]);
      } finally {
        setLoadingVillages(false);
      }
    };

    fetchVillages();
  }, [formData.taluka, formData.district]);


  const handleFileChange = (e) => {
    setDocumentFile(e.target.files[0]);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: type === "checkbox" ? checked : value,
        },
      }));
    } else {
      if (name === "acquisition_proposal_date") {
        const fullDatePattern = /^\d{4}-\d{2}-\d{2}$/;

        // Allow partial typing without blocking (e.g., "2025-", "2025-12-")
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));

        if (!fullDatePattern.test(value)) {
          return; // Don't validate until complete format
        }

        const [yyyy, mm, dd] = value.split("-").map(Number);

        // Validate year, month, day ranges
        const isYearValid = yyyy >= 1900 && yyyy <= 2050;
        const isMonthValid = mm >= 1 && mm <= 12;
        const isDayValid = dd >= 1 && dd <= 31;

        // Check if the typed date is an actual calendar-valid date
        const typedDate = new Date(value);
        const isValidDate =
          typedDate.getFullYear() === yyyy &&
          typedDate.getMonth() + 1 === mm &&
          typedDate.getDate() === dd;

        if (!isYearValid || !isMonthValid || !isDayValid || !isValidDate) {
          alert("❌ Invalid date! Please enter a real date between 1900 and 2050.");
          setFormData((prev) => ({
            ...prev,
            [name]: "", // Clear invalid date
          }));
          return;
        }
        return;
      }

      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "acquisition_proposal_no",
      "acquisition_proposal_date",
      "acquisition_agency",
      "acquisition_purpose",
      "propsal_description",
      "project_description",
      "project_social_benfit",
      "displacement_reason",
      "social_impact"
    ];

    const missingFields = requiredFields.filter(
      (field) => !formData[field] || formData[field].trim() === ""
    );

    if (missingFields.length > 0) {
      alert("Please fill in all required fields marked with *");
      return;
    }

    // Convert exemption value to numeric format expected by backend
    let exemptionValue = "";
    if (exemptionApplicable === "Yes") {
      exemptionValue = "1";
    } else if (exemptionApplicable === "No") {
      exemptionValue = "0";
    }

    if (exemptionApplicable === "Yes" && (!exemptionFile || !exemptionNumber)) {
      alert("Please provide exemption file and number.");
      return;
    }

    setIsLoading(true);

    const safeParseInt = (value) => (value ? parseInt(value) || 0 : 0);
    const safeParseFloat = (value) => (value ? parseFloat(value) || 0.0 : 0.0);
    const safeString = (value) => value || "";

    const proposalPayload = {
      acquisition_proposal_no: safeString(formData.acquisition_proposal_no),
      acquisition_proposal_date: safeString(formData.acquisition_proposal_date),
      propsal_description: safeString(formData.propsal_description),
      acquisition_agency: safeString(formData.acquisition_agency),
      acquisition_purpose: safeString(formData.acquisition_purpose),
      area_unit: formData.area_unit,
      administrative_order_no: "",
      administrative_order_date: "",
      propsal_proceeding_no: "",
      propsal_proceeding_date: "",
      project_id: currentProjectId,
      project_description: safeString(formData.project_description),
      project_social_benfit: safeString(formData.project_social_benfit),
      displacement_reason: safeString(formData.displacement_reason),
      social_impact: safeString(formData.social_impact),
      appointed_administrator: "",
      village_name: safeString(formData.village),
      taluka_name: safeString(formData.taluka),
      dist_name: safeString(formData.district),
      no_of_landparcel: safeParseInt(formData.no_of_landparcel),
      total_area: safeParseInt(formData.total_area),
      acquisition_area: safeParseFloat(formData.acquisition_area),
      date_of_extension: safeString(formData.date_of_extension),
      isactive: "1",
      project_incharge_usr_id: "",
      proposal_amount: safeString(formData.proposal_amount),
    };

    try {
      const formDataToSend = new FormData();
      Object.entries(proposalPayload).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      // Send numeric value (1 or 2) instead of "Yes"/"No"
      formDataToSend.append("is_exemption_applicable", exemptionValue);
      formDataToSend.append("exemption_type", exemptionType);
      formDataToSend.append("exemption_notification_number", exemptionNumber);

      if (exemptionFile) {
        formDataToSend.append("exemptionFile", exemptionFile);
      }

      const response = await apiService.postProposal(formDataToSend);

      if (response?.status === 200) {
        showAlert('Proposal submitted successfully!');
        const newProposalId = response.data?.acquisition_proposal_id;
        if (newProposalId) {
          localStorage.setItem("currentProposalId", newProposalId.toString());
          localStorage.setItem("selectedProposal", JSON.stringify(response.data));
          window.dispatchEvent(new Event("storage"));
        }
        if (onSubmit) onSubmit(response.data);
        window.location.reload();
      } else {
        alert("❌ Submission failed: " + (response?.data?.message || "No response"));
      }
    } catch (error) {
      alert("❌ Failed to submit proposal: " + (error.response?.data?.message || error.message));
    } finally {
      setIsLoading(false);
    }
  };

  const handlePublicClick = () => {
    alert("Proposal made public!");
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 flex justify-between items-center">
          <h2 className="text-xl font-bold">{translations[language].AddLandAcquisitionProposal}</h2>
          {onClose && (
            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 text-2xl font-bold"
            >
              ×
            </button>
          )}
        </div>

        {/* Form Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          <div className="space-y-6">
            {/* Three Column Layout */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div>
                {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                  District
                </label> */}
                {/* District Dropdown */}
                {/* <select
                  name="district"
                  value={formData.district}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border-2 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500"
                >
                  <option value="">Select District</option>
                  {districts.map((d, idx) => (
                    <option key={idx} value={d.dist_name}>{d.dist_name}</option>
                  ))}
                </select> */}
              </div>

              <div>
                {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                  Taluka
                </label> */}
                {/* Taluka Dropdown */}
                {/* <select
                  name="taluka"
                  value={formData.taluka}
                  onChange={handleInputChange}
                  disabled={!formData.district || loadingTalukas}
                  className="w-full px-4 py-3 border-2 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500"
                >
                  <option value="">{loadingTalukas ? 'Loading talukas...' : 'Select Taluka'}</option>
                  {talukas.map((t, idx) => (
                    <option key={idx} value={t.taluka_name}>{t.taluka_name}</option>
                  ))}
                </select> */}
              </div>

              <div>
                {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                  Village
                </label> */}
                {/* Village Dropdown */}
                {/* <select
                  name="village"
                  value={formData.village}
                  onChange={handleInputChange}
                  disabled={!formData.taluka || loadingVillages}
                  className="w-full px-4 py-3 border-2 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500"
                >
                  <option value="">{loadingVillages ? 'Loading villages...' : 'Select Village'}</option>
                  {villages.map((v, idx) => (
                    <option key={idx} value={v.village_name}>{v.village_name}</option>
                  ))}
                </select> */}
              </div>

              {/* Column 1: Basic Information */}
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-4 rounded-lg border-l-4 border-blue-500">
                  <h3 className="text-lg font-semibold text-blue-800 mb-3">
                    {translations[language].BasicInformation}
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].ProposalNo} <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="acquisition_proposal_no"
                        value={formData.acquisition_proposal_no}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].ProposalDate} <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        name="acquisition_proposal_date"
                        value={formData.acquisition_proposal_date}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        required
                        min="1900-01-01"
                        max="2050-12-31"
                      />

                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].ProposalBudget}
                      </label>
                      <input
                        type="number"
                        name="proposal_amount"
                        value={formData.proposal_amount}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        placeholder="Enter amount"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-green-100 p-4 rounded-lg border-l-4 border-green-500">
                  <h3 className="text-lg font-semibold text-green-800 mb-3">
                    {translations[language].LandInformation}
                  </h3>
                  <div className="space-y-3">

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].AreaUnit} <span className="text-red-500"></span>
                      </label>
                      <select
                        name="area_unit"
                        value={formData.area_unit}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                      >
                        <option value="">{translations[language].SelectAreaUnit}</option>
                        {areaUnits.map((unit) => (
                          <option key={unit.area_unit_id} value={unit.unit_name}> {/* ✅ Send name */}
                            {unit.unit_name}
                          </option>
                        ))}
                      </select>
                    </div>


                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].TotalArea}
                      </label>
                      <input
                        type="text"
                        name="total_area"
                        value={formData.total_area}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                        placeholder="Enter total area"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].ToBeAcquisitionLandArea}
                      </label>
                      <input
                        type="text"
                        name="acquisition_area"
                        value={formData.acquisition_area}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                        placeholder="Enter area"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Column 2: Department & Agency */}
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-4 rounded-lg border-l-4 border-purple-500">
                  <h3 className="text-lg font-semibold text-purple-800 mb-3">
                    {translations[language].DepartmentInformation}
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].AcquiredAgency}{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="acquisition_agency"
                        value={formData.acquisition_agency}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].AcquisitionPurpose}{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="acquisition_purpose"
                        value={formData.acquisition_purpose}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 rounded-lg border-l-4 border-orange-500">
                  <h3 className="text-lg font-semibold text-orange-800 mb-3">
                    {translations[language].Descriptions}
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].ProposalDescription}{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="propsal_description"
                        value={formData.propsal_description}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors resize-none"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].ProjectDescription}(अनुसूची - २){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="project_description"
                        value={formData.project_description}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors resize-none"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Column 3: Social Impact */}
              <div className="space-y-4">
                <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-4 rounded-lg border-l-4 border-teal-500">
                  <h3 className="text-lg font-semibold text-teal-800 mb-3">
                    {translations[language].SocialImpact}
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].SocialBenefit} (अनुसूची - २)<span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="project_social_benfit"
                        value={formData.project_social_benfit}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors resize-none"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].DisplacementReason} (अनुसूची - ३){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="displacement_reason"
                        value={formData.displacement_reason}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors resize-none"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {translations[language].SocialImpact} (अनुसूची - ४)<span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="social_impact"
                        value={formData.social_impact}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors resize-none"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

           

            {/* Submit Buttons */}
            <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
              {onClose && (
                <button
                  type="button"
                  onClick={onClose}
                  className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-all duration-200 hover:shadow-lg"
                >
                  {translations[language].Cancel}
                </button>
              )}
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isLoading}
                className={`px-8 py-2 font-medium rounded-lg transition-all duration-200 transform ${isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 hover:shadow-lg hover:-translate-y-0.5"
                  } text-white`}
              >
                {isLoading ? <span>{translations[language].Loading}</span> : <span>{translations[language].SubmitProposal}</span>}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Simple Alert Notification */}
      {showAlertModal && (
        <div className="fixed top-4 right-4 z-50">
          <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
              alertConfig.type === 'warning' ? 'border-yellow-500' :
                alertConfig.type === 'info' ? 'border-blue-500' :
                  'border-green-500'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                      alertConfig.type === 'info' ? 'bg-blue-100' :
                        'bg-green-100'
                  }`}>
                  <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                      alertConfig.type === 'warning' ? 'text-yellow-600' :
                        alertConfig.type === 'info' ? 'text-blue-600' :
                          'text-green-600'
                    }`}>
                    {alertConfig.type === 'error' ? '✕' :
                      alertConfig.type === 'warning' ? '⚠' :
                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
              </div>
              <button
                onClick={() => setShowAlertModal(false)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProposalDetails;